import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SAVELEVEL = function (state, payload) {
  state.row.level = payload
}

const state = {
  rows: [],
  row: null,
  condition: {}
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0501Course cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0501Course search')
    return client.postData({ data: { search: { api: 'M0501CourseService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0501Course add')
    commit('EDIT',
      {
        id: null,
        level: [{'level_code': '', 'level_name': ''}]
        /* files: {},
        relates: {},
        belongs: {} */
      }
    )
  },
  deleteRow: ({ commit, state }, row) => {
    return client.postData({ data: { delete: { api: 'M0502CourseLevelService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('SAVELEVEL', data.delete.output)
      })
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0501Course edit')
    return client.postData({ data: { find: { api: 'M0501CourseService.getDataDetail', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0501Course delete')
    return client.postData({ data: { delete: { api: 'M0501CourseService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0501Course save')
    return client.postData({ data: { save: { api: 'M0501CourseService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0501Course download')
    return client.download({ data: { download: { api: 'M0501CourseService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0501Course/M0501CourseStore.js